import {Component, ElementRef, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TilesService} from '../../../../../core/services/tiles.service';
import {TilePollingService} from '../../../../../core/services/tile-polling.service';
import {TileBaseComponent} from '../tile-base.component';
import {TileToggleElemSetup} from '../../../../../shared/models/tile-template/interfaces';
import {ShadeToolsService} from '../../../../../core/services/shade-tools.service';
import {SimpleBoolStructure} from '../../../../../shared/models/structure';
import {AlarmsService} from '../../../../../core/services/alarms.service';
import {TileHistoryService} from '../../../../../core/services/tile-history.service';
import {SessionService} from '../../../../../core/services/session.service';
import {TileAlarmBadgeComponent} from '../../alarm-badge/tile-alarm-badge.component';
import {PopoverMenuComponent} from '../../../popover-menu/popover-menu.component';
import {SpinnerComponent} from '../../../spinner/spinner.component';
import {NgClass} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SchedulesViewerComponent} from '../../../schedules-viewer/schedules-viewer.component';
import { PermissionsService } from 'src/core/services/permissions.service';
import { MotiChatService } from 'src/moti/services/moti-chat.service';
import { ViewportIntersectionService } from '../../../../../core/services/viewport-intersection.service';
import {TooltipDirective} from '../../../../directives/tooltip/tooltip.directive';

@Component({
  selector: 'motn-tile-toggle',
  templateUrl: './tile-toggle.component.html',
  styleUrls: ['./tile-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TileAlarmBadgeComponent,
    PopoverMenuComponent,
    SpinnerComponent,
    NgClass,
    FormsModule,
    SchedulesViewerComponent,
    TooltipDirective,
  ],
})
export class TileToggleComponent extends TileBaseComponent implements OnInit, OnDestroy {
  @Input() elemDef: TileToggleElemSetup;

  structure: SimpleBoolStructure;


  constructor(
    protected tilesService: TilesService,
    protected tilePollingService: TilePollingService,
    protected shadeTools: ShadeToolsService,
    protected alarmsService: AlarmsService,
    protected tileHistoryService: TileHistoryService,
    protected permissionsService: PermissionsService,
    protected session: SessionService,
    protected motiChatService: MotiChatService,
    protected elementRef: ElementRef,
    protected viewportService: ViewportIntersectionService,
  ) {
    super(tilesService, tilePollingService, shadeTools, alarmsService, tileHistoryService, permissionsService, session, motiChatService, elementRef, viewportService);
  }


  protected onInit(): void {
    this.structure = this.tile.Structure as SimpleBoolStructure;
  }


  protected onDestroy(): void {
  }


  toggleValue($event): void {
    this.sendBooleanTileValue(!this.rawValue);
    $event.preventDefault();
  }
}
